var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReaction = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 10a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.002 15.001c-1.774 0-3.266-1.153-3.739-2.728a.312.312 0 0 1 .306-.397h6.863a.314.314 0 0 1 .311.254.311.311 0 0 1-.006.143c-.468 1.575-1.96 2.728-3.735 2.728Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.813 10a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.125a8.125 8.125 0 1 0 0-16.25 8.125 8.125 0 0 0 0 16.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export { SvgReaction as ReactComponent };